export const COLUMN_LIST = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
  { label: 8, value: 8 },
  { label: 9, value: 9 },
  { label: 10, value: 10 },
];

export const OPERATION_TYPE_LIST = [
  { label: '加法(A+B=C)', value: '+' },
  { label: '减法(A-B=C)', value: '-' },
  { label: '乘法(AxB=C)', value: '*' },
  { label: '除法(C÷A=B)', value: '/' },
  { label: '*混合(A±B=C)', value: '+-' },
  { label: '*混合(AxB=C/C÷A=B)', value: '*/' },
  { label: '*混合(AxB±C=D)', value: '*+-' },
  { label: '*混合(A÷B±C=D)', value: '/+-' },
  // { label: '加减乘除随机', value: 'mixin' },
];